import { isNativeAppBoth as checkNativeAppBoth } from '@wconcept/wconcept-common/utils/userAgentUtil';

export const TOAST_BOTTOM_WITH_ACTIONBAR = 94;
export const TOAST_BOTTOM_DEFAULT = 60;

/** 앱은 네이티브 액션바(94), 웹은 ToastPopup 기본값(60) */
export function getToastBottom(isNativeApp?: boolean): number {
  if (typeof window === 'undefined') return TOAST_BOTTOM_DEFAULT;

  const isNative = isNativeApp ?? checkNativeAppBoth(navigator.userAgent);

  return isNative ? TOAST_BOTTOM_WITH_ACTIONBAR : TOAST_BOTTOM_DEFAULT;
}
